import { render, staticRenderFns } from "./ErWeiMaBack.vue?vue&type=template&id=018c6692&scoped=true"
import script from "./ErWeiMaBack.vue?vue&type=script&lang=js"
export * from "./ErWeiMaBack.vue?vue&type=script&lang=js"
import style0 from "./ErWeiMaBack.vue?vue&type=style&index=0&id=018c6692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c6692",
  null
  
)

export default component.exports